import React from "react";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import BaseModal from "../../../../components/ui/BaseModal";
import BaseButton from "../../../../components/ui/BaseButton";
import { showToast } from "../../../../store/toast/toastSlice";
import { deactivateCompanyUser } from "../../../../services/api/company";

const ConfirmDeactivateUserModal = ({
  deactivateModalOpen,
  setDeactivateModalOpen,
  userId,
  refetchUsers,
}) => {
  const dispatch = useDispatch();

  const { isPending: isDeactivating, mutateAsync: deactivateUserMutation } =
    useMutation({
      mutationFn: deactivateCompanyUser,
      onSuccess: () => {
        dispatch(
          showToast({
            message: "User deactivated successfully",
            type: "success",
          })
        );
        refetchUsers?.();
        setDeactivateModalOpen(false);
      },
      onError: (error) => {
        dispatch(
          showToast({
            message:
              error?.response?.data?.message || "Failed to deactivate user",
            type: "error",
          })
        );
      },
    });

  async function handleDeactivate() {
    try {
      await deactivateUserMutation(userId);
    } catch (err) {}
  }

  return (
    <BaseModal
      className="-top-72"
      open={deactivateModalOpen}
      close={() => setDeactivateModalOpen(false)}
    >
      <div className="container">
        <h6 className="text-dark border-bottom mb-4 pb-1">
          Are you sure you want to deactivate this user?
        </h6>
        <p>
          Once deactivated, the user will no longer have access until
          reactivated.
        </p>
      </div>

      <div
        className="flex items-center justify-center bg-white py-6 mt-3"
        style={{ boxShadow: "5px 0px 14px 5px rgba(0, 0, 0, 0.07)" }}
      >
        <BaseButton
          className="py-[5px] px-2 bg-[#E8E8E8] text-dark"
          fullWidth={false}
          onClick={() => setDeactivateModalOpen(false)}
        >
          Cancel
        </BaseButton>
        <BaseButton
          disabled={isDeactivating}
          isLoading={isDeactivating}
          className="py-[5px] px-4 ml-4"
          color="error"
          fullWidth={false}
          onClick={handleDeactivate}
        >
          Deactivate
        </BaseButton>
      </div>
    </BaseModal>
  );
};

export default ConfirmDeactivateUserModal;
